import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import styled from 'foundations-theming/utils';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRowWrapper = styled.div.withConfig({
  displayName: "SettingsRowWrapper__StyledRowWrapper",
  componentId: "sc-31bogb-0"
})(["margin-block-end:", ";", ""], ({
  theme
}) => theme.space['500'], ({
  $cssStyles
}) => $cssStyles);
export default function SettingsRowWrapper(props) {
  const {
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(rest);
  const cssProps = useMapTokenPropsToCSS(tokenProps);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledRowWrapper, Object.assign({
      className: className,
      $cssStyles: cssProps
    }, restProps))
  );
}